export enum FormFields {
  Name = 'name',
  State = 'state',
}

export const FormFieldsList = [FormFields.Name, FormFields.State];

export enum MarketAreaModals {
  SAVE_MARKET_AREA_MODAL = 'SAVE_MARKET_AREA_MODAL',
  DELETE_MARKET_AREA_MODAL = 'DELETE_MARKET_AREA_MODAL',
  CONFIRMATION_DELETE_MARKET_AREA_MODAL = 'CONFIRMATION_DELETE_MARKET_AREA_MODAL'
}
